<template>
  <div class="song">
    <nav class="navbar navbar-light bg-light border-bottom">
      <div class="container-fluid">
        <div class="navbar-brand">{{ song.title }}</div>

        <div class="nav-item" v-b-modal="'edit-song'">
          <div class="btn btn-outline-secondary">
            <b-icon-pencil></b-icon-pencil>
          </div>
        </div>
      </div>
    </nav>
    
    <Modal id="edit-song">
      <template v-slot:header>
        Edit {{ song.title }}
      </template>

      <template v-slot:content="{ changed, close }">
        <Editor :song="song" v-on="{ changed, saved: updated(close) }"></Editor>
      </template>
    </Modal>
    
    <div class="song-content-container">
      <div class="song-content">
        <Empty v-if="$apollo.queries.song.loading" icon="b-icon-hourglass-split" header="Loading"></Empty>
        <Splitter v-else :body="song.body" preset="song">
          <template v-slot="{ split }">
            <Sections :sections="split" v-on:sectioned="sectioned" v-on:escaped="escaped">
              <template v-slot:default="{ section }">
                <Pane :type="'song'" :body="section.body" />
              </template>

              <template v-slot:preview="{ section }">
                <h5>{{ section.title }}</h5>
                <p v-html="section.body" class="section-preview"></p>
              </template>
            </Sections>
          </template>
        </Splitter>
      </div>
    </div>
  </div>
</template>

<script>
  import gql from 'graphql-tag'

  import Splitter from '../components/Splitter';
  import Sections from '../components/Sections';
  import Pane from '../components/Pane';
  
  import Modal from '../components/Editor';
  import Editor from '../components/editors/Song';
  import Empty from '../components/Empty';

  export default {
    components: {
      Splitter,
      Sections,
      Pane,
      Modal,
      Editor,
      Empty
    },

    beforeRouteUpdate(to, from, next) {
      this.id = to.params.songId;
      next();
    },

    beforeDestroy() {
      this.$store.dispatch('frameClosed');
    },

    data() {
      return {
        id: this.$route.params.songId,
        song: {}
      }
    },

    methods: {
      sectioned(idx) {
        this.$store.dispatch('sectioned', idx);
        this.$store.dispatch('positioned', 0);
      },

      updated(callback) {
        return function({ updated_at }) {
          callback();
          this.$store.dispatch('updated', updated_at)
        }.bind(this);
      },

      escaped() {
        this.$router.push({ name: this.$route.name.replace(/song$/, 'songs.index') })
      }
    },

    apollo: {
      song: {
        query: gql`
          query GetSong($id: uuid!) {
            song: songs_by_pk(id: $id) {
              id
              title
              body
              key
              author
              created_at
              updated_at
            }
          }
        `,

        variables() {
          return {
            id: this.id
          }
        },

        result({ data : { song } }) {
          this.$store.dispatch('frameOpened', { type: 'song', id: song.id, timestamp: song.updated_at })
        }
      }
    }
  }
</script>

<style scoped>
  .song {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .song-content-container {
    display: flex;
    flex: 1;
    min-height: 0;
  }

  .song-content {
    flex: 1;
    overflow: auto;

    position: relative;

    white-space: pre-wrap;
  }

  .section-preview {
    max-height: 15em;
    overflow-y: hidden;
  }
</style>
